import { render } from "./TrainedByZonal.vue?vue&type=template&id=183ad3bb&scoped=true"
import script from "./TrainedByZonal.vue?vue&type=script&lang=js"
export * from "./TrainedByZonal.vue?vue&type=script&lang=js"

import "./TrainedByZonal.vue?vue&type=style&index=0&id=183ad3bb&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183ad3bb"]])

export default __exports__